import httpClient from "../../../custom-hooks/httpClient";

export const verifyWalletNumber = (
  transferDetails,
  setReceiverName,
  beneficiaries,
  setIsExistingBeneficiary,
  toast
) => {
  httpClient
    .post(`/transfers/wallet-to-other-wallet/verify-wallet-number`, {
      wallet_account_number: transferDetails.receiver_wallet_number,
    })
    .then(({ status, data }) => {
      if (status === 200) {
        const receiver = data.wallet[0];
        setReceiverName(`${receiver.firstname} ${receiver.lastname}`);
        // Check if the validated account number is on the beneficiaries list.
        const isBeneficiary = beneficiaries.some(
          (beneficiary) =>
            beneficiary.recipient_account_number ===
            transferDetails.receiver_wallet_number
        );
        setIsExistingBeneficiary(isBeneficiary);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message || "Error verifying wallet number");
    });
};

export const chooseBeneficiary = async (
  senderAccount,
  setBeneficiaries,
  setShowModal,
  bankOptions
) => {
  try {
    const { data, status } = await httpClient.get(
      `/beneficiaries/${senderAccount}`
    );
    if (status === 200) {
      for (const key in data) {
        const bankCode = data[key].bank_code;
        const bankName = bankOptions.find(
          (bank) => bank.value.split("***")[0] === bankCode,
        )?.label;
        data[key]["bankName"] = bankName;
      }
      setBeneficiaries(data);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setShowModal(true);
  }
};

export const beneficiarySelection = (
  beneficiary,
  setReceiverName,
  handleChangeTransferDetails,
  setShowModal,
  setBeneficiarySelected
) => {
  setReceiverName(beneficiary.name);
  handleChangeTransferDetails({
    target: {
      name: "receiver_wallet_number",
      value: beneficiary.recipient_account_number,
    },
  });
  setShowModal(false);
  setBeneficiarySelected(true);
};

export const areFieldsSet = (transferDetails) => {
  const { transaction_pin, narration, ...fields } = transferDetails;
  return !Object.values(fields).includes("");
};

export const fetchBanks = (setBanks, toast) => {
  httpClient
    .post(`/transfers/wallet-to-bank/get-banks`, {})
    .then(({ status, data }) => {
      if (status === 200) {
        setBanks(data.bankArray);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message || "Error getting banks");
    });
};

export const fetchBeneficiaries = (senderAccount, setBeneficiaries) => {
  httpClient
    .get(`/beneficiaries/${senderAccount}`)
    .then(({ status, data }) => {
      if (status === 200) {
        setBeneficiaries(data.data);
      }
    })
    .catch((err) => {
      console.error(err.response.data.message);
    });
};
